export default __webpack_public_path__ + "static/media/diagrama_pacote.56a59c55.jpeg";